import { exportsModule } from '@cian/mf-registry/browser';

import { createHeaderConstructor } from '../services/WebComponentV2/createHeaderConstructor';
import { createApplicationContext } from '../services/applicationContext/createApplicationContext';
import { createApplicationState } from '../services/applicationState';
import { init as initAuthContext } from '../services/authContext';
import { init as initEvents } from '../services/events';
import { registerHeaderUIAPIController } from '../services/headerUIAPIController/bridge';
import { createHeaderUIAPIController } from '../services/headerUIAPIController/createHeaderUIAPIController';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  initAuthContext(context, store);
  initEvents(context, store, false);
  const apiController = createHeaderUIAPIController(store);
  registerHeaderUIAPIController(
    {
      microfrontendName: context.config.getStrict<string>('projectName'),
      imageVersion: context.config.getStrict<string>('version.commit'),
    },
    apiController,
  );

  exportsModule({
    ui: {
      '/v2/get-header-microfrontend/': () => ({
        customElementConstructor: createHeaderConstructor(context, store, apiController),
      }),
    },
  });
}
